import { render, staticRenderFns } from "./set-destroy-ignore.vue?vue&type=template&id=fefe6dee&scoped=true"
import script from "./set-destroy-ignore.vue?vue&type=script&lang=js"
export * from "./set-destroy-ignore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefe6dee",
  null
  
)

export default component.exports